import { Container, Group, Stack, Text } from "@mantine/core"
import { InfoBox, ProgressBox, Select } from "@tfg/ui"
import { Trans, useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

type Props = {
  certificateTypes: string[]
  setCertificateType: (value: string | null) => void
  countValidatedCertificate: number
  countCollectedCertificate: number
  validatedPercent: number
  collectedPercent: number
}

export function DocumentsKPIView({
  certificateTypes,
  setCertificateType,
  countValidatedCertificate,
  countCollectedCertificate,
  validatedPercent,
  collectedPercent,
}: Props) {
  const { t } = useTranslation("home")

  if (isNaN(validatedPercent) && isNaN(collectedPercent)) {
    return (
      <Container w="100%">
        <InfoBox
          width="100%"
          title={t("documents.noDocuments.title")}
          message={t("documents.noDocuments.message")}
        />
      </Container>
    )
  }

  return (
    <Stack w="100%">
      <Group>
        <Select
          clearable
          onChange={setCertificateType}
          data={certificateTypes}
          placeholder={t("documents.certificateType")}
        />
      </Group>
      <Stack bg="white" px="xs" py="md" w="100%">
        <ProgressBox
          label={t("documents.label")}
          sections={[
            {
              value: validatedPercent,
              text: countValidatedCertificate.toString(),
              label: t("documents.verified"),
            },
            {
              value: collectedPercent,
              color: "var(--progress-bar-color-unfilled)",
              textColor: "var(--progress-bar-unfilled-text)",
              text: countCollectedCertificate.toString(),
              label: t("documents.pending"),
            },
          ]}
          helpHoverText={
            <Link to="/documents" target="_blank">
              <Text td="underline">
                {validatedPercent === 100
                  ? t("documents.totalTextCompleted")
                  : t("documents.totalText")}
              </Text>
            </Link>
          }
        />
        <Stack gap="0">
          <Text fz="sm">
            <Trans
              ns="home"
              i18nKey="documents.total"
              values={{
                total: countValidatedCertificate + countCollectedCertificate,
              }}
              components={{
                strong1: (
                  <strong
                    style={{
                      color: "var(--progress-bar-color-filled)",
                    }}
                  />
                ),
              }}
            />
          </Text>
          <Text fz="sm">
            <Trans
              ns="home"
              i18nKey="documents.complete"
              values={{
                percent: Number.isNaN(validatedPercent) ? 0 : validatedPercent,
              }}
              components={{
                strong1: (
                  <strong
                    style={{
                      color: "var(--progress-bar-color-filled)",
                    }}
                  />
                ),
              }}
            />
          </Text>
        </Stack>
      </Stack>
    </Stack>
  )
}
